'use client'

import Link from 'next/link'

interface FooterAlternateSiteLinkProps {
    label: string
    linkText: string
    alternateUrl: string | undefined
}

export default function FooterAlternateSiteLink({ label, linkText, alternateUrl }: FooterAlternateSiteLinkProps) {
    if (!alternateUrl) {
        return null
    }

    return (
        <div className="my-8 flex flex-wrap items-center justify-center gap-3 text-sm">
            <span className="text-muted-foreground">{label}</span>
            <Link
                href={alternateUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary duration-150">
                {linkText}
            </Link>
        </div>
    )
}
